module.exports = __webpack_public_path__ + "img/home-lazer.d2526ebb.svg";